import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Nav from "./Nav";
import img1 from './logo2.png'

const Header = () => {
  return (
    <MainHeader>
      <NavLink to="/">
        <img src={img1} alt="my logo img" className="logo"/>
      </NavLink>
      <Nav />
    </MainHeader>
  );
};

const MainHeader = styled.header`
  padding: 0 4.8rem;
  height: 10rem;
  background-color: ${({ theme }) => theme.colors.bg};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .logo {
    height: 20rem;
    mix-blend-mode : multiply;

  }
`;
export default Header;


{/* <Auth0Provider
  domain={domain}
  clientId={clientId}
  redirectUri={window.location.origin}></Auth0Provider> */}